import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { localStore } from '../App';

const NotificationRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    try 
    {
      console.log("useEffect :: redirect after tap on notification?");
      
      if (history) 
      {
        console.log("useEffect :: redirect after tap on notification? History obj loaded");

        // get route from local storage - that's the one set when the app was opened from a notification
        localStore.get('pendingPushRoute').then((pendingPushRoute: string | null) => {
          console.log("useEffect :: redirect after tap on notification? pendingPushRoute:", pendingPushRoute);
          
          if (pendingPushRoute) 
          {
            console.log("useEffect :: redirect after tap on notification? pendingPushRoute found, pushing to history");

            localStore.remove('pendingPushRoute');
            history.push(pendingPushRoute);
          }
        });
      }
    } 
    catch (error) 
    {
      console.log("App register :: error:", error);
    }
  }, [history]);

  return null; // This component doesn't render anything
};

export default NotificationRedirect; 